import { userConstants } from "../../constant";

export function productDescription(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_PRODUCT_DESCRIPTION:
      return {
        productDescription: action.payload,
      };
    default:
      return state;
  }
}
